import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-submit-application',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './submit-application.component.html',
})
export class SubmitApplicationComponent {
  @Output() close = new EventEmitter<void>();

  contactForm!: FormGroup;
  isSubmitted = false;
  constructor(private fb: FormBuilder, private apiService: ApiService) {}

  ngOnInit(): void {
    document.body.style.overflow = 'hidden';

    this.contactForm = this.fb.group({
      senderFirstName: [
        '',
        [Validators.required, Validators.pattern(/^[A-Za-z]+(?: [A-Za-z]+)*$/)],
      ],
      senderLastName: [
        '',
        [Validators.required, Validators.pattern(/^[A-Za-z]+(?: [A-Za-z]+)*$/)],
      ],
      senderEmail: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
          ),
        ],
      ],
      countryCode: ['IT', Validators.required],
      mobilePhone: ['', [Validators.required, Validators.pattern(/^[0-9]*$/)]],
      emailBody: ['', [Validators.required, Validators.minLength(10)]],
      cvFile: [null, Validators.required],
    });
  }

  closeModal() {
    this.close.emit();
    document.body.style.overflow = 'auto';
  }

  onFileChange(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.contactForm.patchValue({
        cvFile: file,
      });
    }
  }

  onSubmit() {
    this.isSubmitted = true;
    this.contactForm.markAllAsTouched();
    if (this.contactForm.invalid) return;
    console.log('this.contactForm valid', this.contactForm.value);

    this.close.emit();

    this.apiService.contactUs(this.contactForm.value).subscribe({
      next: (response) => {
        console.log('response', response);
      },
      error: (error) => {
        console.error('Error submitting contact us form', error);
      },
    });
  }
}
